import React from "react";
import styles from "./Platform.module.scss";

const platforms = [
  "SAP - All Industries",
  "SAP for Retail",
  "SAP for Fashion",
  "SAP CAR",
  "SAP on-Premise",
  "SAP on AWS / GCP / AZURE",
  "RISE with SAP",
  "SAP BTP",
];

const industries = [
  "Retail",
  "Fashion",
  "Oil",
  "Ecommerce",
  "Manufacturing",
  "Consumer Goods",
  "Pharma",
  "B2C Commerce",
  "Wholesale & Distribution",
  "CPG",
];

const Platform = () => {
  return (
    <div className={styles.tableContainer}>
      {/* Single Table for Desktop */}
      <div className={styles.desktopTable}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Platforms</th>
              <th>Industries</th>
            </tr>
          </thead>
          <tbody>
            {platforms.map((platform, index) => (
              <tr key={index}>
                <td>{platform}</td>
                <td>{industries[index] || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Separate Tables for Mobile */}
      <div className={styles.mobileTables}>
        {/* Platforms Table */}
        <table className={styles.mobileTable}>
          <thead>
            <tr>
              <th>Platforms</th>
            </tr>
          </thead>
          <tbody>
            {platforms.map((platform, index) => (
              <tr key={index}>
                <td>{platform}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Industries Table */}
        <table className={styles.mobileTable}>
          <thead>
            <tr>
              <th>Industries</th>
            </tr>
          </thead>
          <tbody>
            {industries.map((industry, index) => (
              <tr key={index}>
                <td>{industry}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Platform;
